import React, { useEffect, useState } from 'react'
import AddCommonService from './AddCommonService'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import axiosInstance from '../../../api/axiosInstance'
import { useDispatch } from 'react-redux'
import { removeData } from '../../../Redux/Feature/AdminSlice'

function EditCommonService() {
    const {id} = useParams()
    const [serviceData, setServiceData] = useState({})
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const fetchCommonServiceById = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-common-service-by-id/${id}`)
            console.log(response)
            if(response.status === 200){
                setServiceData(response.data.data)
            }

        } catch (error) {
            console.log(error)
            if(error.response.status === 401 || error.response.status === 403){
                navigate('/Admin/login')
                dispatch(removeData())
            }
        }
    }

    console.log(serviceData)

    useEffect(() => {
        fetchCommonServiceById()
    }, [id])

  return (
    <AddCommonService isEdit={true} serviceData={serviceData} />
  )
}

export default EditCommonService
